import { first } from "@pdfking/rfunc"
import selector from "../dom/selector"

export default (
  element: null | string,
  behaviour?: boolean | ScrollIntoViewOptions
) => {
  const el = first(selector(element || window.location.hash || "body"))
  return el ? el.scrollIntoView(behaviour) : null
}
